define('views/pages/wishlist/index',['require','jquery','underscore','mediator','lib/utils','helpers/application','views/base/page','views/pages/wishlist/wishes/page','models/pages/wishlist/wishes/page','models/pages/wishlist/wishes/wishlist-collection','views/pages/wishlist/wishes/table','models/pages/wishlist/offers/page','models/filter/index','models/filter-list','models/pages/wishlist/offers/filter-days','models/pages/wishlist/offers/wishlist-results','views/pages/wishlist/offers/page','views/filter/index','views/filter-list','views/pages/wishlist/offers/filter-days','views/pages/wishlist/offers/wishlist-results','text!templates/pages/wishlist/index.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        mediator = require('mediator'),
        utils = require('lib/utils'),
        applicationHelper = require('helpers/application'),
        PageView = require('views/base/page'),

        WishlistWishesView = require('views/pages/wishlist/wishes/page'),
        WishlistWishesPageModel = require('models/pages/wishlist/wishes/page'),
        WishlistWishesCollection = require('models/pages/wishlist/wishes/wishlist-collection'),
        WishlistWishesTableView = require('views/pages/wishlist/wishes/table'),

        WishlistOffersPageModel = require('models/pages/wishlist/offers/page'),
        Filter = require('models/filter/index'),
        FilterList = require('models/filter-list'),
        FilterDays = require('models/pages/wishlist/offers/filter-days'),
        WishlistOffersResults = require('models/pages/wishlist/offers/wishlist-results'),

        WishlistOffersPageView = require('views/pages/wishlist/offers/page'),
        FilterView = require('views/filter/index'),
        FilterListView = require('views/filter-list'),
        FilterDaysView = require('views/pages/wishlist/offers/filter-days'),
        WishlistOffersResultsView = require('views/pages/wishlist/offers/wishlist-results'),

        template = require('text!templates/pages/wishlist/index.ejs');

    var WishlistPageView = PageView.extend({
        id: 'pages-wishlist-page',
        autoRender: true,
        template: template,
        regions: {
            'wishes': '#wishlist-wishes',
            'offers': '#wishlist-offers'
        },
        listen: {
            'change:loading model': 'render',
            'change:page model': 'onChangePage'
        },
        initialize: function() {
            PageView.prototype.initialize.apply(this, arguments);

            var self = this;

            this.delegate('click', '#wishlist-tabs>.nav-tabs a', this.onActivateTab);

            mediator.wishlistResultCount.on('change:count', function(){
                self.reRenderOffersCount();
            });
        },
        render: function() {
            PageView.prototype.render.apply(this, arguments);

            this.subview('wishes', this.createWishes());
            this.subview('offers', this.createOffers());
            this.reRenderOffersCount();
        },
        reRenderOffersCount: function(){
            var $oc = this.$('.offers-count');
            var count = mediator.wishlistResultCount.get('count');
            $oc[(count > 0 ? 'removeClass' : 'addClass')]('hidden');
            $oc.text(count);
        },
        createOffers: function(){
            // CREATE MODELS
            var page = new WishlistOffersPageModel({});

            page.items = new WishlistOffersResults([]);
            page.filter = new Filter({ showSummary: true });
            page.filterList = new FilterList({ type: 'wishlist-result' });
            page.filterList.setFilter(page.filter);
            page.filterDays = FilterDays.generate();


            var applyFilters = _.debounce(function () {
                var filtered = page.filter.get('filtered');
                filtered = page.filterDays.applyFilterTo(filtered);
                filtered = utils.applySearch(filtered, page.get('search'));

                page.items.reset(filtered);
            }, 200);

            page.items.on('destroy', function(item) {
                var items, found;

                items = page.filter.get('source');

                found = _.findWhere(items, { id: item.get('id') });
                if (found) {
                    items.splice(_.indexOf(items, found), 1);
                }

                items = page.filter.get('filtered');

                found = _.findWhere(items, { id: item.get('id') });
                if (found) {
                    items.splice(_.indexOf(items, found), 1);
                }

                page.filterDays.fill(page.items);
            });



            page.on('change:search', applyFilters);
            page.filter.on('filterChanged', applyFilters);
            page.filterDays.on('change:active', applyFilters);

            // CREATE VIEWS
            var pageView = new WishlistOffersPageView({ model: page });

            pageView.subview('filter-days', new FilterDaysView({ collection: page.filterDays }));
            pageView.subview('filter', new FilterView({ model: page.filter, region: 'wishlist-result-filter' }));
            pageView.subview('filter-list', new FilterListView({ model: page.filterList, region: 'wishlist-result-filter-list' }));
            pageView.subview('table', new WishlistOffersResultsView({ collection: page.items }));

            // LOAD DATA
            page.items.fetch().complete(function() {

                utils.prepareSearch(page.items, [
                    'countryName',
                    'sellerName',
                    'goodsFullName'
                ]);

                page.filter.setup({
                    schema: [
                        {
                            name: 'countryName',
                            caption: 'Страна'
                        },
                        {
                            name: 'sellerName',
                            caption: 'Продавец'
                        },
                        {
                            name: 'goodsFullName',
                            caption: 'Тип'
                        },
                        {
                            name: 'price',
                            caption: 'Цена',
                            type: 'range'
                        }
                    ],
                    source: page.items.toJSON()
                });
                // page.filter.trigger('filterChanged');

                page.filterDays.fill(page.items);
                page.set('loaded', true);
            });
            return pageView;
        },

        createWishes: function(){
            var pageModel = new WishlistWishesPageModel({ active: this.model.get('type') });
            var pageView = new WishlistWishesView({
                model: pageModel
            });

            var items = new WishlistWishesCollection([]);
            var table = new WishlistWishesTableView({ collection: items });

            pageModel.items = items;

            pageView.subview('table', table);

            var activeType = this.model.get('type');
            items.filterActive = activeType === 'all' ? '' : ((activeType === 'active') + '');
            items.fetch().complete(function() {
                pageModel.set('loaded', true);
            });

            return pageView;
        },

        onChangePage: function(){
            this.subview('offers').dispose();
            this.subview('wishes').dispose();

            applicationHelper.redirectTo('wishlist#show', { page: this.model.get('page'), type: 'active'});
        },
        onActivateTab: function(ev){
            this.model.set('page', this.$(ev.target).data().page);
        },
        dispose: function() {
            if (this.disposed) { return; }
            PageView.prototype.dispose.apply(this, arguments);
        }
    });

    return WishlistPageView;
});

